import { COLLABORATOR } from "../actions/Actions";

const initalState = {
  loading: false,
  error: false,
  list: [],
};

export function collaboratorReducer(state = initalState, action) {
  const { type, payload } = action;

  switch (type) {
    case COLLABORATOR.LOADING:
      return { ...state, loading: true, error: false, list: [] };
    case COLLABORATOR.SUCCESS:
      return { ...state, loading: false, list: payload, error: false };
    case COLLABORATOR.ERROR:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
}
